var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3OnOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 16a22 22 0 100 44 22 22 0 000-44zm0 40a18 18 0 110-36.001A18 18 0 0138 56zm-2-31h4v26h-4V25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_On_off.06615cfe.svg";
export { SvgJ3OnOff as ReactComponent };